import {SelectionSetNode, ArgumentNode} from 'query-api-graphql';

import {MakeAllFieldsRequired} from 'util/Types';

interface UninitializedFormState {
  entityListingFieldName: null;
}

export interface RelatedResultsFormState {
  /** Name of the field on the selected entity schema listing field that selections are being made for */
  backlinkFieldName: string | null;

  /** Backlink field selections */
  backlinkSelections: SelectionSetNode;

  /** Name of the entity link field on the selected result schema that is being used to join entities */
  joinKeyFieldName: string | null;

  /** Whether or not to include only the latest backlinked item */
  onlyIncludeLatestItem: boolean;
}

/** @package */
export type CompletedRelatedResultsFormState = MakeAllFieldsRequired<RelatedResultsFormState>;

/** @package */
export function isCompletedRelatedResultsFormState(
  relatedResultsFormState: RelatedResultsFormState
): relatedResultsFormState is CompletedRelatedResultsFormState {
  return (
    relatedResultsFormState.joinKeyFieldName != null &&
    relatedResultsFormState.backlinkFieldName != null &&
    relatedResultsFormState.backlinkSelections.selections.length > 0
  );
}

export function getCompletedRelatedResultsFormStates(
  relatedResultFormStates: Array<RelatedResultsFormState>
): Array<CompletedRelatedResultsFormState> {
  return relatedResultFormStates.filter(
    (relatedResultsFormState): relatedResultsFormState is CompletedRelatedResultsFormState =>
      isCompletedRelatedResultsFormState(relatedResultsFormState)
  );
}

/** @package */
export interface InitializedFormState {
  entityListingFieldName: string;
  entityFieldSelections: SelectionSetNode;
  entityFilterArguments: Array<ArgumentNode>;
  relatedResultsFormStates: Array<RelatedResultsFormState>;
}

/** @package */
export type FormState = UninitializedFormState | InitializedFormState;
